<template>
  <div class="sale-by-product-report">
    <v-card flat class="report-page-card">
      <ReportViewBar
        title="Sale By Product"
        :start="start"
        :end="end"
        :export-data="exportData"
        :export-fields="exportFields"
      />

      <v-card-text class="report-content">
        <CategoryByProduct
          :start="start"
          :end="end"
          @export-data="setExportData"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";

const CategoryByProduct = () =>
  import("@/modules/ReportView/GlobalReport/ProfitByCategory.vue");

export default {
  name: "sale-by-product-report",

  components: {
    ReportViewBar,
    CategoryByProduct,
  },

  data() {
    return {
      start: null,
      end: null,
      exportData: [],
      exportFields: {
        Name: "name",
        Qty: "totalQty",
        "Qty %": "qtyPercent",
        Sale: "totalPrice",
        Cost: "totalCost",
        Profit: "totalProfit",
        "Profit %": "profitPercent",
      },
    };
  },

  created() {
    this.start = this.$route.query.start || null;
    this.end = this.$route.query.end || null;
  },

  methods: {
    setExportData(rows) {
      this.exportData = rows || [];
    },
  },
};
</script>

<style scoped>
.sale-by-product-report {
  background: #f5f7fb;
  min-height: 100vh;
  padding: 16px;
}

.report-page-card {
  border-radius: 18px;
  overflow: hidden;
}

.report-content {
  padding: 20px;
}

@media print {
  .sale-by-product-report {
    background: #fff;
    padding: 0;
  }

  .report-page-card {
    box-shadow: none !important;
    border-radius: 0;
  }

  .report-content {
    padding: 0;
  }

  .no-print {
    display: none !important;
  }
}
</style>